/** React */
import React, {
  Children,
  ComponentType,
  ReactNode,
  cloneElement,
  isValidElement,
  useMemo,
} from "react";

/** CSS */
import "./index.css";

/** Props */
type MenuWrapperProps = {
  children: ReactNode;
};

const ALLOWED_CHILD_COMPONENT = ["MenuItem"];

export function MenuWrapper({ children }: MenuWrapperProps) {
  const menuItemComponents = useMemo(() => {
    return Children.map(children, (child) => {
      if (!isValidElement(child)) return null;

      const childType = child.type as ComponentType & { displayName?: string };

      if (!ALLOWED_CHILD_COMPONENT.includes(childType.displayName)) {
        return null;
      }

      return cloneElement(child);
    });
  }, [children]);

  return <div className="menu">{menuItemComponents}</div>;
}
